export const getRemainingDay = (timestamp = 0) => {
    let remainingDay = 0;
    const today = new Date().getTime();
    if (timestamp && timestamp > today) {
        remainingDay = Math.floor((timestamp - today) / 1000 / 24 / 60 / 60);
    }
    return remainingDay;
};

export const getRemainingMonth = (timestamp = 0) => {
    let remainingMonth = 0;
    const today = new Date().getTime();
    if (timestamp && timestamp > today) {
        remainingMonth = Math.floor(
            (timestamp - today) / 1000 / 24 / 60 / 60 / 30
        );
    }
    return remainingMonth;
};
